
// Should match the values in color_picker.scss
export const EDITOR_COLORS: {[key: string]: string}  = {
  black: "#000000",
  red: "#ff0000",
  blue: "#0000ff",
  green: "#00ff00",
  yellow: "#e2e630",
}
